import { AutocompleteInput } from '@ui-components/neo.tax';

import { AutocompleteFormType } from './forms.types';

export const AutocompleteForm = ({ form }: { form: AutocompleteFormType }): React.ReactElement | null => (
  <AutocompleteInput
    id={form.id}
    options={form.options}
    value={form.value}
    onChange={form.onChange}
    placeholder={form.placeholder}
    disabled={form.disabled}
    error={!!form.validator?.(form.value)}
    errorText={form.validator?.(form.value)}
  />
);
